import { Link } from '@xing-com/link';

import { Styled } from './content-switcher-more-item.styles';
import type { ContentSwitcherMoreItemProps } from './content-switcher-more-item.types';

export const ContentSwitcherMoreItem: React.FC<
  ContentSwitcherMoreItemProps
> = ({
  children,
  href,
  icon: Icon,
  miniBadge,
  onClick,
  popOver,
  selected,
  to,
  ...rest
}) => {
  const forwardedAs = to || href ? Link : 'button';
  const onClickHandler = (e: React.MouseEvent): void => {
    popOver.handleHide();
    if (onClick) onClick(e);
  };

  return (
    <Styled.MoreListItem
      selected={selected}
      forwardedAs={forwardedAs}
      {...(to ? { to } : {})}
      {...(href ? { href } : {})}
      onClick={onClickHandler}
      role="menuitem"
      {...rest}
    >
      <Styled.MoreItemInner>
        {miniBadge ? <Styled.MiniBadge /> : null}
        {Icon ? (
          <Styled.MoreItemIcon>
            <Icon height={24} width={24} aria-hidden="true" />
          </Styled.MoreItemIcon>
        ) : null}
        {children}
      </Styled.MoreItemInner>
    </Styled.MoreListItem>
  );
};
